<template>
    <div>
        <CustomMultiSelect :name="name" :items="items" :empty-value="emptyValue" v-model="internalValue"
                           item-label="label" item-value="value" :label="label" v-if="!loading" :required="required"
                           :placeholder="placeholder" :noPlaceholder="noPlaceholder" :disabled="disabled"/>

        <!-- Input text field that appears when OTHER is selected -->
        <div v-if="showOtherInput" class="mt-2">
            <CustomInputText
                :name="name + '_other'"
                :label="$t('message.horseCreate.otherOption')"
                v-model="internalOtherValue"
                :placeholder="$t('message.horseCreate.enterOtherOption')"
                :disabled="disabled"/>
        </div>
    </div>
</template>

<script>
    import CustomSelectOne from "./inner/CustomSelectOne";
    import CustomMultiSelect from "./inner/CustomMultiSelect.vue";
    import CustomInputText from "./CustomInputText.vue";

    export default {
        name: "CustomMultiSelectMarking",
        props: {
            name: {
                type: String,
            },
            label: {
                type: String,
            },
            items: {
                type: Array,
                default: () => [],
            },
            emptyValue: {
                type: Boolean,
                default: true,
            },
            required: {
                type: Boolean,
                default: false,
            },
            placeholder: {
                type: String,
                default: "",
            },
            noPlaceholder: {
                type: Boolean,
                default: false,
            },
            itemLabel: {
                type: String,
                default: "name",
            },
            modelValue: null,
            otherValue: {
                type: String,
                default: "",
            },
            disabled: {
                type: Boolean,
                default: false,
            },
        },

        emits: ["update:modelValue", "update:otherValue"],

        computed: {
            internalValue: {
                get() {
                    return this.modelValue;
                },
                set(value) {
                    this.$emit("update:modelValue", value);
                },
            },
            internalOtherValue: {
                get() {
                    return this.otherValue;
                },
                set(value) {
                    this.$emit("update:otherValue", value);
                },
            },
            showOtherInput() {
                // Check if "OTHER" is selected in the current values
                if (!this.modelValue || !Array.isArray(this.modelValue)) {
                    return false;
                }
                return this.modelValue.some(value =>
                    value.toUpperCase() === 'OTHER'
                );
            },
        },

        data() {
            return {
                loading: false,
            };
        },

        components: {CustomMultiSelect, CustomSelectOne, CustomInputText},
    };
</script>

<style scoped>

</style>
